import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '..//topic.service';
import { ActivatedRoute } from '@angular/router';
import { SelfcorrectingService } from '../selfcorrecting.service';


@Component({
  selector: 'app-t-modulo',
  templateUrl: './t-modulo.component.html',
  styleUrls: ['./t-modulo.component.css']
})
export class TModuloComponent extends GeneralTeacherComponent {

  message: string;
  dimension: number[] = [0, 0];
  withMessage: boolean = false;

  messageArray: number[][] = [];
  length: number;


  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute);
    this.type = "modulo"
    this.title = this.get("modulo");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.dimension = this.configuration.typespecifics.dimension;
    this.message = this.configuration.typespecifics.message;
    this.withMessage = !(this.message == "" || this.message == undefined);

    if(this.withMessage){
      this.fillArray();
    }
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/modulo.png";
    definition.level = 2;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.message = this.withMessage?this.message:"";
    definition.typespecifics.dimension = this.dimension;
    definition.key = definition.key.concat("%", this.message, "%", this.dimension.toString());

    return definition;
  }

  generate(){
    console.log(this.message);
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    if(Math.random() > 0.5){
      this.message = this.generate01(this.dimension[0]*this.dimension[1])
      this.withMessage = true;
      this.fillArray();
    } else {
      this.message = "";
      this.withMessage = false;
    }
  }

  /**
   * generates a 01-string of given length
   * @param length - length of string
   */
  generate01(length: number){
    let result = "";
    for(let i = 0; i < length; i++){
      result = result.concat((Math.random() > 0.5?"0":"1"));
    }
    return result;
  }

  /** normalizes the message */
  normalize(s: string): string {
    if (!s) {
      return "";
    }
    return s.replace(/[^01]/, "");
  }

  /** fills the message array based on the message */
  fillArray() {
    this.messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      this.messageArray.push(elem);
    }
  }

  /** recomputes the message array */
  changeDimension() {
    this.message = this.messageArray.map(v => v.join("")).join("");
    this.messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      this.messageArray.push(elem);
    }
    this.length = this.dimension[0] * this.dimension[1];
  }

  reset(){
    super.reset();
    this.title = this.get("modulo");
    this.dimension = [];
    this.message = undefined;
    this.withMessage = false;
  }

}
